import { useEffect, useState } from "react";
import { downloadCatalog, fetchCatalogs } from "../../../api/catalogs";
import downloadIcon from "../../../images/icons/download_dark.svg";
import pdfIcon from "../../../images/icons/pdf_icon.svg";
import loaderIcon from "../../../images/icons/loader.svg";

const formatCatalogName = (filename = "") =>
  filename.replace(/\.pdf$/i, "").replace(/_/g, " ");

const Catalogs = () => {
  const [catalogs, setCatalogs] = useState([]);
  const [status, setStatus] = useState("loading");
  const [downloadingId, setDownloadingId] = useState(null);

  useEffect(() => {
    const loadCatalogs = async () => {
      try {
        const response = await fetchCatalogs();
        setCatalogs(response?.result ?? []);
        setStatus("success");
      } catch (e) {
        setCatalogs([]);
        setStatus("error");
      }
    };

    loadCatalogs();
  }, []);

  const openFile = (url) => {
    if (!url) return;

    const link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownload = async (id) => {
    if (!id || downloadingId) return;

    setDownloadingId(id);
    try {
      const response = await downloadCatalog(id);
      openFile(response?.url);
    } catch (e) {
      // ошибка уже обработана interceptor'ом
    } finally {
      setDownloadingId(null);
    }
  };

  if (status === "loading") {
    return (
      <div className="loader">
        <img src={loaderIcon} alt="loader" />
      </div>
    );
  }

  if (!catalogs.length) {
    return (
      <div className="flex-column gap-grid column-start w-100">
        <h3>Ничего не найдено</h3>
      </div>
    );
  }

  return (
    <div className="flex-column gap-grid column-start w-100">
      <div className="cards w-100">
        {catalogs.map((item) => (
          <div
            className="card-item flex-column column-start flex-between border-radius-base"
            key={item.id}
          >
            <span className="title text-m">
              {formatCatalogName(item.filename)}
            </span>
            <div className="flex-row gap-4x">
              <button
                type="button"
                onClick={() => handleDownload(item.id)}
                disabled={downloadingId === item.id}
                className="download btn-outlined size-m flex-row"
              >
                Скачать
                <img alt="download" src={downloadIcon} />
              </button>
              <img src={pdfIcon} alt="pdf document"></img>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Catalogs;
